import axios, { AxiosInstance } from "axios";
import config from "./config";
import { defaultFirebaseClient } from "./clients/FirebaseClient";

type AxiosInstanceWithOperationId = AxiosInstance & {
    operationId: string;
};
const napAxios: AxiosInstanceWithOperationId = axios.create({
    baseURL: config.apiEndpoint,
    headers: {
        Accept: "application/json",
    },
}) as AxiosInstanceWithOperationId;

napAxios.interceptors.request.use(async (options) => {
    if (napAxios.operationId) {
        options.headers = {
            ...options.headers,
            "X-Operation-ID": napAxios.operationId,
        };
        napAxios.operationId = "";
    }
    const user = defaultFirebaseClient.currentUser;
    if (user) {
        const idToken = await user.getIdToken();
        if (idToken) {
            options.headers = {
                ...options.headers,
                Authorization: `Bearer ${idToken}`,
            };
        }
    }
    return options;
});

// use port from stubrunner when unit tests are running
napAxios.interceptors.request.use(async function (options) {
    if (process.env.JEST_WORKER_ID !== undefined) {
        const baseURL = new URL(config.apiEndpoint);
        baseURL.port = "9876";
        options.baseURL = baseURL.toString();
    }
    return options;
});

export default napAxios;
